import { UiSchema } from "@rjsf/utils";

// UI Schema for form layout and styling - EXACT MATCH TO ORIGINAL FORM
export const uiSchema: UiSchema = {
  "ui:submitButtonOptions": {
    submitText: "Submit",
    props: {
      variant: "contained",
      color: "primary",
      size: "large",
      sx: {
        backgroundColor: "#5a6c7d",
        color: "white",
        px: 3,
        py: 1.2,
        textTransform: "none",
        fontWeight: 600,
        fontSize: "0.95rem",
        minWidth: "150px",
        border: "none",
        "&:hover": {
          backgroundColor: "#4a5c6d",
          border: "none",
        },
      },
    },
  },

  agentType: {
    "ui:widget": "radio",
    "ui:options": {
      inline: false,
    },
    "ui:enumNames": [
      "I have worked with OptiMed before and am an existing agent",
      "I have not worked with OptiMed and am a new agent",
    ],
  },

  // Root Level Contact Fields
  contactEmail: {
    "ui:placeholder": "your.email@example.com",
    "ui:help": "This is incase there are any issues with the submitted ACH",
  },

  contactPhone: {
    "ui:widget": "PhoneWidget",
    "ui:help": "This is incase there are any issues with the submitted ACH",
    "ui:options": {
      label: false,
    },
  },

  contactAgency: {
    "ui:placeholder": "Agency name",
    "ui:help": "This is incase there are any issues with the submitted ACH",
  },

  pdbConsent: {
    "ui:field": "pdbConsentField",
  },

  achInstructions: {
    "ui:field": "achInstructionsField",
  },

  updateType: {
    "ui:widget": "checkboxes",
    "ui:options": {
      inline: false,
    },
  },

  // Existing Agent - Licensed Agent Name Fields
  agentFirstName: {
    "ui:placeholder": "",
  },
  agentMiddleName: {
    "ui:placeholder": "",
  },
  agentLastName: {
    "ui:placeholder": "",
  },
  agentSuffix: {
    "ui:placeholder": "",
  },

  // Existing Agent - Contact Fields
  existingContactEmail: {
    "ui:placeholder": "",
    "ui:help": "This is incase there are any issues with the submitted ACH",
  },
  existingContactPhone: {
    "ui:widget": "PhoneWidget",
    "ui:help": "This is incase there are any issues with the submitted ACH",
    "ui:options": {
      label: false,
    },
  },
  existingContactAgency: {
    "ui:placeholder": "",
    "ui:help": "This is incase there are any issues with the submitted ACH",
  },
  existingAgentEmail: {
    "ui:placeholder": "",
  },

  // New Agent Path
  isLicensedAgent: {
    "ui:widget": "radio",
    "ui:options": {
      inline: false,
    },
    "ui:enumNames": ["I am the licensed agent", "I will be filling out the paperwork for the licensed agent"],
  },

  // Form Filler
  fillerName: {
    "ui:options": {
      label: false,
    },
  },
  fillerEmail: {
    "ui:placeholder": "your.email@example.com",
  },
  fillerPhone: {
    "ui:widget": "PhoneWidget",
    "ui:help": "This is incase there are any issues so we can reach out to you",
    "ui:options": {
      label: false,
    },
  },

  // Agent Information
  optimedAgentId: {
    "ui:placeholder": "Paste Agent ID from email",
    "ui:help":
      "*Please do not add any extra spacing, before or after the entered Agent ID. This links your information to your OptiMed profile",
  },

  // Group Information
  carrierOfProduct: {
    "ui:help": "Select the Carrier provided in your OptiMedHealth Welcome E-mail",
    "ui:enumNames": [
      "Zurich",
      "SelfFunded",
      "Everest",
      "BreckPoint",
      "Nationwide",
      "Chubb",
      "Markel",
      "ShelterPoint",
      "Providence (IHP)",
      "Principal",
      "Old Republic",
    ],
  },

  groupNumber: {
    "ui:widget": "NumericWidget",
    "ui:help": "This number may not have been created. If you do not have this number, please leave blank",
  },

  // Agent Info
  agentSSN: {
    "ui:widget": "password",
    "ui:help": "Required for Carrier Appointment.",
  },
  agentSex: {
    "ui:widget": "radio",
    "ui:options": {
      inline: true,
    },
    "ui:help": "Required for Carrier Appointment",
    "ui:enumNames": ["Male", "Female"],
  },
  agentDOB: {
    "ui:widget": "date",
    "ui:help": "Required for Carrier Appointment",
  },

  agentOfficePhone: {
    "ui:widget": "PhoneWidget",
    "ui:options": {
      label: false,
    },
  },
  agentCell: {
    "ui:widget": "PhoneWidget",
    "ui:options": {
      label: false,
    },
  },

  // Agency Ownership
  isAgencyOwner: {
    "ui:widget": "radio",
    "ui:options": {
      inline: false,
    },
    "ui:enumNames": ["Yes", "No", "I am being paid as an individual"],
  },

  commissionsToAgency: {
    "ui:widget": "radio",
    "ui:options": {
      inline: true,
    },
    "ui:enumNames": ["Yes", "No"],
  },

  ownerEmail: {
    "ui:help": "Please note that this is required for Nationwide appointment",
  },

  // Agency Info
  agencyName: {
    "ui:help": "This needs to match what is on your agency's W-9",
  },

  hasDBA: {
    "ui:widget": "radio",
    "ui:options": {
      inline: true,
    },
    "ui:enumNames": ["Yes", "No"],
  },

  taxId: {
    "ui:widget": "TaxIdWidget",
    "ui:help": "Required for Appointment.",
  },

  operatingAs: {
    "ui:widget": "radio",
    "ui:options": {
      inline: false,
    },
    "ui:enumNames": ["Corporation", "Partnership", "Individual", "Sole Proprietorship"],
  },

  // Background Questions - Updated field names
  backgroundQ1: {
    "ui:widget": "radio",
    "ui:options": {
      inline: false,
    },
    "ui:enumNames": ["Yes", "No"],
  },
  backgroundQ1Explanation: {
    "ui:widget": "textarea",
    "ui:options": {
      rows: 4,
    },
  },
  backgroundQ1Docs: {
    "ui:widget": "file",
    "ui:options": {
      accept: ".pdf,.jpg,.jpeg,.png",
    },
  },

  backgroundQ2: {
    "ui:widget": "radio",
    "ui:options": {
      inline: false,
    },
    "ui:enumNames": ["Yes", "No"],
  },
  backgroundQ2Explanation: {
    "ui:widget": "textarea",
    "ui:options": {
      rows: 4,
    },
  },
  backgroundQ2Docs: {
    "ui:widget": "file",
    "ui:options": {
      accept: ".pdf,.jpg,.jpeg,.png",
    },
  },

  backgroundQ3: {
    "ui:widget": "radio",
    "ui:options": {
      inline: false,
    },
    "ui:enumNames": ["Yes", "No"],
  },
  backgroundQ3Explanation: {
    "ui:widget": "textarea",
    "ui:options": {
      rows: 4,
    },
  },
  backgroundQ3Docs: {
    "ui:widget": "file",
    "ui:options": {
      accept: ".pdf,.jpg,.jpeg,.png",
    },
  },

  backgroundQ4: {
    "ui:widget": "radio",
    "ui:options": {
      inline: false,
    },
    "ui:enumNames": ["Yes", "No"],
  },
  backgroundQ4Explanation: {
    "ui:widget": "textarea",
    "ui:options": {
      rows: 4,
    },
  },
  backgroundQ4Docs: {
    "ui:widget": "file",
    "ui:options": {
      accept: ".pdf,.jpg,.jpeg,.png",
    },
  },

  backgroundQ5: {
    "ui:widget": "radio",
    "ui:options": {
      inline: false,
    },
    "ui:enumNames": ["Yes", "No"],
  },
  backgroundQ5Explanation: {
    "ui:widget": "textarea",
    "ui:options": {
      rows: 4,
    },
  },
  backgroundQ5Docs: {
    "ui:widget": "file",
    "ui:options": {
      accept: ".pdf,.jpg,.jpeg,.png",
    },
  },

  backgroundQ6: {
    "ui:widget": "radio",
    "ui:options": {
      inline: false,
    },
    "ui:enumNames": ["Yes", "No"],
  },
  backgroundQ6Explanation: {
    "ui:widget": "textarea",
    "ui:options": {
      rows: 4,
    },
  },
  backgroundQ6Docs: {
    "ui:widget": "file",
    "ui:options": {
      accept: ".pdf,.jpg,.jpeg,.png",
    },
  },

  backgroundQ7: {
    "ui:widget": "radio",
    "ui:options": {
      inline: false,
    },
    "ui:enumNames": ["Yes", "No"],
  },
  backgroundQ7Explanation: {
    "ui:widget": "textarea",
    "ui:options": {
      rows: 4,
    },
  },
  backgroundQ7Docs: {
    "ui:widget": "file",
    "ui:options": {
      accept: ".pdf,.jpg,.jpeg,.png",
    },
  },

  // License Fields - Updated names
  dateAgentLicenseEffective: {
    "ui:widget": "date",
  },
  dateAgentLicenseExpires: {
    "ui:widget": "date",
  },
  agentLicenseDocument: {
    "ui:widget": "file",
    "ui:options": {
      accept: ".pdf,.jpg,.jpeg,.png",
    },
  },

  dateAgencyLicenseEffective: {
    "ui:widget": "date",
  },
  dateAgencyLicenseExpires: {
    "ui:widget": "date",
  },
  agencyLicenseDocument: {
    "ui:widget": "file",
    "ui:options": {
      accept: ".pdf,.jpg,.jpeg,.png",
    },
  },

  // E&O
  dateEOEffective: {
    "ui:widget": "date",
  },
  dateEOExpires: {
    "ui:widget": "date",
  },
  eoDocument: {
    "ui:widget": "file",
    "ui:options": {
      accept: ".pdf,.jpg,.jpeg,.png",
    },
    "ui:help": "I attest that I am an insured under the E&O certificate and/or policy attached",
  },

  // ACH Fields
  achEmail: {
    "ui:placeholder": "your.email@example.com",
    "ui:help": "This is incase there are any issues with the submitted ACH",
  },
  achPhone: {
    "ui:widget": "PhoneWidget",
    "ui:help": "This is incase there are any issues with the submitted ACH",
    "ui:options": {
      label: false,
    },
  },
  achAgency: {
    "ui:help": "This is incase there are any issues with the submitted ACH",
  },

  // Update fields for existing agents
  updateAgentLicenseNumber: {
    "ui:widget": "hidden",
  },
  updateStateOfAgentLicense: {
    "ui:widget": "hidden",
  },
  updateDateAgentLicenseEffective: {
    "ui:widget": "hidden",
  },
  updateDateAgentLicenseExpires: {
    "ui:widget": "hidden",
  },
  updateAgentLicenseDocument: {
    "ui:widget": "hidden",
  },

  updateAgencyLicenseNumber: {
    "ui:widget": "hidden",
  },
  updateStateOfAgencyLicense: {
    "ui:widget": "hidden",
  },
  updateDateAgencyLicenseEffective: {
    "ui:widget": "hidden",
  },
  updateDateAgencyLicenseExpires: {
    "ui:widget": "hidden",
  },
  updateAgencyLicenseDocument: {
    "ui:widget": "hidden",
  },

  updateEOPolicyNumber: {
    "ui:widget": "hidden",
  },
  updateDateEOEffective: {
    "ui:widget": "hidden",
  },
  updateDateEOExpires: {
    "ui:widget": "hidden",
  },
  updateEODocument: {
    "ui:widget": "hidden",
  },

  newCarrierLicensedAgentNPN: {
    "ui:widget": "hidden",
  },
};
